var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPraticidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 15.1C28.7 11.4931 27.2671 8.03384 24.7167 5.48335C22.1662 2.93285 18.7069 1.5 15.1 1.5C11.4931 1.5 8.03384 2.93285 5.48335 5.48335C2.93285 8.03384 1.5 11.4931 1.5 15.1C1.5 23.5881 10.9163 32.4281 14.0783 35.1583C14.373 35.3793 14.7316 35.4987 15.1 35.4983M28.7 35.5V30.4M23.6 35.4998C23.1491 35.4998 22.7167 35.3207 22.3979 35.0019C22.0791 34.6831 21.9 34.2507 21.9 33.7998V26.9998C21.9 26.72 21.969 26.4445 22.1009 26.1978C22.2329 25.9511 22.4237 25.7407 22.6565 25.5854L27.7565 22.1854C28.0359 21.9991 28.3642 21.8996 28.7 21.8996C29.0358 21.8996 29.3641 21.9991 29.6435 22.1854L34.7435 25.5854C34.9763 25.7407 35.1671 25.9511 35.2991 26.1978C35.431 26.4445 35.5 26.72 35.5 26.9998V33.7998C35.5 34.2507 35.3209 34.6831 35.0021 35.0019C34.6833 35.3207 34.2509 35.4998 33.8 35.4998H23.6ZM20.2 15.1C20.2 17.9167 17.9167 20.2 15.1 20.2C12.2833 20.2 10 17.9167 10 15.1C10 12.2833 12.2833 10 15.1 10C17.9167 10 20.2 12.2833 20.2 15.1Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPraticidade);
export default __webpack_public_path__ + "static/media/praticidade.bbb0e7ec9e9476dceb6029031d1fa45a.svg";
export { ForwardRef as ReactComponent };